<template>
  <div class="box1">
    <div class="title">产品经理</div>
    <div class="smallTitle">用户需求的代言人 产品方案的规划师</div>
    <img src="../../../assets/coursePage/pm/box1/main.png" alt="" />
    <div class="txt">
      如何才能成为一名好的产品经理？除了具备夯实的理论基础
      <p>项目经验才是高薪就业的杀手锏</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  width: 100%;
  padding-bottom: 80px;
  background: url("../../../assets/coursePage/pm/box1/1.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;

  .title {
    font-size: 64px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #1e2259;
    line-height: 90px;
    -webkit-text-stroke: 1px #273f6e;
    text-stroke: 1px #273f6e;
    margin: 84px 0 0 60px;
  }
  .smallTitle {
    background: url("../../../assets/coursePage/pm/box1/box.png") no-repeat;
    font-size: 28px;
    font-family: PingFang SC;
    width: 580px;
    height: 88px;
    font-weight: 400;
    color: #273f6e;
    line-height: 36px;
    letter-spacing: 1px;
    margin: 20px 0 0 60px;
    padding: 16px 0 0 32px;
    box-sizing: border-box;
    background-size: contain;
  }
  img {
    margin: 32px 0 0 44px;
    width: 662px;
    height: 386px;
  }
  .txt {
    position: relative;
    z-index: 5;
    margin-top: -20px;
    width: 686px;
    height: 156px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 16px;
    border: 3px solid #ffffff;
    backdrop-filter: blur(4px);
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 40px;
    margin-left: 32px;
    padding-top: 32px;
    box-sizing: border-box;
    text-align: center;
    p {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5f59ff;
      line-height: 44px;
      margin-top: 8px;
    }
  }
}
</style>
